export const PIXEL_PERSON_GRID_WIDTH = 14;
export const PIXEL_PERSON_GRID_HEIGHT = 18;

/** Extra viewBox space so tall hair / hover bob are not clipped at the SVG edge. */
export const PIXEL_PERSON_VIEWBOX_PAD_TOP = 2;
export const PIXEL_PERSON_VIEWBOX_PAD_BOTTOM = 1;

export const PIXEL_PERSON_VIEWBOX_HEIGHT =
  PIXEL_PERSON_GRID_HEIGHT + PIXEL_PERSON_VIEWBOX_PAD_TOP + PIXEL_PERSON_VIEWBOX_PAD_BOTTOM;
